var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { InstantGamesHostingTypesEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { computedFrom } from "aurelia-binding";
var InstantGameBasicMeta = /** @class */ (function (_super) {
    __extends(InstantGameBasicMeta, _super);
    function InstantGameBasicMeta(notificationService, i18N, tokenClient, dialogClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        _this.dialogClientService = dialogClientService;
        _this.isHostingTypePlayport = false;
        return _this;
    }
    Object.defineProperty(InstantGameBasicMeta.prototype, "isPromotion", {
        get: function () {
            return this._isPromotion;
        },
        set: function (value) {
            this._isPromotion = value;
            this.item.updateBrandInstantGame.isPromotion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InstantGameBasicMeta.prototype, "redirectUrl", {
        get: function () {
            return this._redirectUrl;
        },
        set: function (value) {
            this._redirectUrl = value;
            this.item.updateBrandInstantGame.redirectUrl = this._redirectUrl;
        },
        enumerable: false,
        configurable: true
    });
    InstantGameBasicMeta.prototype.onActivated = function () {
        this._redirectUrl = this.item.navigationInfo && this.item.navigationInfo.redirectUrl ? this.item.navigationInfo.redirectUrl : "";
        this._isPromotion = this.item.navigationInfo && this.item.navigationInfo.isPromotion ? this.item.navigationInfo.isPromotion : false;
        this.item.updateBrandInstantGame = {
            hasChanges: true,
            instantGameId: this.item.instantGameId,
            brandId: this.item.navigationInfo ? this.item.navigationInfo.brandId : null
        };
    };
    Object.defineProperty(InstantGameBasicMeta.prototype, "showManageTemplate", {
        get: function () {
            return !this.isHostingTypePlayport && ((this.item.navigationInfo && this.item.navigationInfo.brandId) // is brand
                || (this.item.navigationInfo && !this.item.navigationInfo.operatorId));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InstantGameBasicMeta.prototype, "isReadonly", {
        get: function () {
            if (this.item && !this.item.navigationInfo)
                return false;
            else
                return this.item.navigationInfo.operatorId || this.item.navigationInfo.brandId && this.item.instantGameId > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InstantGameBasicMeta.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClient.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InstantGameBasicMeta.prototype, "isAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    InstantGameBasicMeta.prototype.editBranding = function () {
        require("../dialogs/instant-game-branding-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.InstantGameBranding, this.item, false, false, true);
    };
    InstantGameBasicMeta.prototype.onSelectInstantGamesHostingType = function (event) {
        if (event.detail.item.id == InstantGamesHostingTypesEnum.Playport) {
            this.isHostingTypePlayport = true;
        }
        else {
            this.item.playportUrl = null;
            this.item.externalGameId = null;
            this.isHostingTypePlayport = false;
        }
    };
    __decorate([
        computedFrom("_isPromotion"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InstantGameBasicMeta.prototype, "isPromotion", null);
    __decorate([
        computedFrom("_redirectUrl"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InstantGameBasicMeta.prototype, "redirectUrl", null);
    InstantGameBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            TokenClient, DialogClientService])
    ], InstantGameBasicMeta);
    return InstantGameBasicMeta;
}(ChildComponent));
export { InstantGameBasicMeta };
